import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { apiRequest, formatPrice } from "../../api/client";
import { useToast } from "../../context/ToastContext";

export default function AdminOrderDetails() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState("pending");
  const [error, setError] = useState("");
  const toast = useToast();

  function load() {
    apiRequest(`/api/orders/${id}`, { tokenType: "admin" })
      .then((response) => {
        setOrder(response.data);
        setStatus(response.data.order_status);
      })
      .catch((err) => setError(err.message));
  }

  useEffect(load, [id]);

  async function saveStatus() {
    try {
      const response = await apiRequest(`/api/orders/${id}/status`, {
        method: "PATCH",
        tokenType: "admin",
        body: { order_status: status },
      });
      setOrder({ ...order, ...response.data });
      toast?.show("Order status updated.");
    } catch (err) {
      setError(err.message);
    }
  }

  if (error) return <p className="form-status error">{error}</p>;
  if (!order) return <LoadingSpinner />;

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div><span className="eyebrow">Order Details</span><h1>{order.order_number}</h1></div>
      </div>
      <div className="admin-detail-grid">
        <section className="admin-panel">
          <h2>Customer</h2>
          <p><strong>{order.customer_name}</strong></p>
          <p>{order.customer_email}</p>
          <p>{order.customer_phone}</p>
          <p>{order.city} {order.address}</p>
          {order.notes && <p>{order.notes}</p>}
        </section>
        <section className="admin-panel">
          <h2>Status</h2>
          <label>
            <span>Order status</span>
<select
  value={status}
  onChange={(event) => setStatus(event.target.value)}
  style={{
    padding: "10px 14px",
    marginBottom:"15px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    backgroundColor: "#fff",
    color: "#1f2937",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    outline: "none",
    minWidth: "180px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    transition: "all 0.2s ease",
  }}
>
  <option value="pending">Pending</option>
  <option value="paid">Paid</option>
  <option value="completed">Completed</option>
  <option value="cancelled">Cancelled</option>
  <option value="refunded">Refunded</option>
</select>
          </label>
          <Button type="button" onClick={saveStatus}>Save Status</Button>
        </section>
      </div>
      <section className="admin-panel">
        <h2 style={{marginBottom:"20px"}}>Products</h2>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Product</th><th>Qty</th><th>Unit</th><th>Total</th></tr></thead>
            <tbody>
              {order.items.map((item) => (
                <tr key={item.id}><td>{item.product_name}</td><td>{item.quantity}</td><td>{formatPrice(item.discount_price || item.unit_price)}</td><td>{formatPrice(item.total)}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="summary-lines admin-summary-lines">
          <div><span>Subtotal</span><strong>{formatPrice(order.subtotal)}</strong></div>
          <div><span>Discount</span><strong>-{formatPrice(order.discount)}</strong></div>
          <div className="summary-total"><span>Total</span><strong>{formatPrice(order.total)}</strong></div>
        </div>
      </section>
    </div>
  );
}
